import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { useState } from 'react';
function EmployerSignUpIndustryFocus() {
    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
      const form = event.currentTarget;
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
  
      setValidated(true);
    };
    const items = [
      { id: 1, name: 'Pharma' },
      { id: 2, name: 'Biotech' },
      { id: 3, name: 'Life Sciences' },
      { id: 4, name: 'CRO' },
      { id: 5, name: 'MedTech' },
      { id: 6, name: 'Healthcare Staffing' },

    ];

   // State to keep track of checked items
const [checkedItems, setCheckedItems] = useState([]);

// Handle checkbox change event
const handleCheckboxChange = (event) => {
  const itemName = event.target.value;
  setCheckedItems(prevState =>
    prevState.includes(itemName)
      ? prevState.filter(item => item !== itemName) // Remove from checkedItems if already checked
      : [...prevState, itemName] // Add to checkedItems if not already checked
  );
};

    return (
    <Container fluid className='m-0 p-0' >
       <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg text-center'>
                <Container>
                    <h2 class="text-white pt-3">Sign Up</h2>
                </Container>
            </div>
   
        <Container className='p-4'>
      
        <Row>
        <Col sm={3} className='progressbar-bg'>
        <ul class="StepProgress">
    <li class="StepProgress-item is-done">Company Details</li>
    <li class="StepProgress-item is-done">Industry Focus</li>
    <li class="StepProgress-item ">Contact Person Details</li>
    <li class="StepProgress-item ">Account Security</li>
    <li class="StepProgress-item"> Preview and Submit</li>
      </ul>
        </Col>
        <Col sm={5} style={{margin:'auto'}}>        
    <h6 style={{color:'#025EA9'}}>Employeer</h6>
    <Container className='m-auto'>   
    <Form noValidate validated={validated} onSubmit={handleSubmit}>      
        <Row>
        <Card className='rounded p-4' style={{backgroundColor:'#EBF2F7', border:'1px solid #025EA9'}}> 
        <h6>Industry Focus</h6>
        
        <div className="checkbox-list-container">
      
      <form className="checkbox-list-form">
        {items.map(item => (
          <div
            className={`checkbox-item ${checkedItems.includes(item.name) ? 'active' : ''}`}
            key={item.id}
          >
            <label htmlFor={item.id}>{item.name}</label>
            <input
              type="checkbox"
              id={item.id}
              value={item.name}
              checked={checkedItems.includes(item.name)} // Check if item is in checkedItems
              onChange={handleCheckboxChange}
            />
          </div>
        ))}

        
      </form>

      <div className="selected-items">
       
        <ul>
          {checkedItems.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
      
    </div>
           
            
           
     
         
         
         </Card>
         </Row>
        <Row>
        <Col className='text-center mt-4'>
        <Card.Link  as={Link} to="/EmployerSignUpCompanyDetails" className='mr-4 pr-4'><i class="bi bi-arrow-left"></i> Back  </Card.Link> 
        <Button type="submit" className='rounded-button ml-2'> Save and continue <i class="bi bi-arrow-right"></i></Button>
        </Col>
        </Row>
       </Form>
       </Container>
       </Col>
    </Row>
      </Container>

    

     
    </Container>

  );


}

export default EmployerSignUpIndustryFocus